var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgApplicationBannerActionIcon = function SvgApplicationBannerActionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.85.416c.65 0 2.238 8.077 4.44 10.241 3.726 3.665 8.607 3.608 8.409 4.242-.199.635-5.858 1.091-7.699 2.653-4.637 3.934-4.5 11.15-5.15 10.855-.652-.294-.457-5.94-3.79-9.947C7.46 16.536 2 15.534 2 14.9c0-.635 3.846-.342 6.923-3.755S12.198.416 12.85.416Z",
    fill: "#000"
  })));
};

export default SvgApplicationBannerActionIcon;